// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Dashboard from "./pages/Dashboard";
import AboutPage from "./pages/AboutPage";
import LearnMorePage from "./pages/LearnMorePage";
import ContactPage from "./pages/ContactPage";
import ContactForm from "./pages/ContactForm";

function App() {
  return (
    <Router>
      <Navbar />
      <MainContent />
    </Router>
  );
}

function MainContent() {

  return (
    <div className="mt-16 min-h-screen">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/learn-more" element={<LearnMorePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contact-form" element={<ContactForm />} />
      </Routes>
    </div>
  );
}

export default App;
